(() => {
  const configElement = document.querySelector('[data-anya-review-i18n]');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const { labels, count, dual, stars, form, media } = config;
  const isArabic = document.documentElement.lang === 'ar';
  const scope = '.jdgm-widget, .jdgm-write-review-modal';
  const excluded = '.jm-review-content, .jm-reviewer-info, .jdgm-rev, .jdgm-carousel-item, script, style, textarea, input';

  const translate = (value) => {
    if (!isArabic) return value;
    const text = value.trim();
    if (labels[text]) return value.replace(text, labels[text]);
    const number = text.match(/^(\d+)\s+(?:avis|reviews?)$/i);
    if (number) {
      if (number[1] === '1') return labels['1 avis'];
      if (number[1] === '2') return dual;
      return count.replace('{count}', number[1]);
    }
    const rating = text.match(/^(\d+(?:\.\d+)?)(?: out of 5)? stars?$/i);
    return rating ? stars.replace('{rating}', rating[1]) : value;
  };

  const formatReviewDates = () => {
    const dateElements = '.jdgm-widget [class*="timestamp"], .jdgm-write-review-modal [class*="timestamp"], .jdgm-widget .jm-text, .jdgm-write-review-modal .jm-text';
    document.querySelectorAll(dateElements).forEach((element) => {
      if (element.dataset.anyaDateFormatted === 'true') return;
      const match = element.textContent.trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
      if (!match) return;
      const [, month, day, year] = match;
      element.textContent = `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
      element.dataset.anyaDateFormatted = 'true';
    });
  };

  const buildSelect = (id, labelText, options) => {
    const field = document.createElement('div');
    field.className = 'anya-review-fields__field';
    const label = document.createElement('label');
    label.htmlFor = id;
    label.textContent = labelText;
    const select = document.createElement('select');
    select.id = id;
    select.required = true;
    select.dataset.anyaReviewDetail = labelText;
    const prompt = document.createElement('option');
    prompt.value = '';
    prompt.textContent = form.choose;
    prompt.disabled = true;
    prompt.selected = true;
    select.append(prompt);
    options.forEach((value) => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      select.append(option);
    });
    select.addEventListener('change', () => select.removeAttribute('aria-invalid'));
    field.append(label, select);
    return field;
  };

  const buildCheckboxGroup = (id, labelText, options) => {
    const field = document.createElement('div');
    field.className = 'anya-review-fields__field anya-review-fields__field--scents';
    field.dataset.anyaReviewDetail = labelText;
    const fieldset = document.createElement('fieldset');
    fieldset.id = id;
    const legend = document.createElement('legend');
    legend.textContent = labelText;
    const choices = document.createElement('div');
    choices.className = 'anya-review-fields__choices';
    options.forEach((value, index) => {
      const choice = document.createElement('label');
      const input = document.createElement('input');
      input.type = 'checkbox';
      input.name = `${id}[]`;
      input.value = value;
      input.id = `${id}-${index + 1}`;
      input.addEventListener('change', () => fieldset.removeAttribute('aria-invalid'));
      const text = document.createElement('span');
      text.textContent = value;
      choice.append(input, text);
      choices.append(choice);
    });
    fieldset.append(legend, choices);
    field.append(fieldset);
    return field;
  };

  const fitReviewViewport = () => {
    const viewport = window.visualViewport;
    document.documentElement.style.setProperty('--anya-review-viewport-height', `${viewport?.height || window.innerHeight}px`);
    document.documentElement.style.setProperty('--anya-review-viewport-top', `${viewport?.offsetTop || 0}px`);
  };

  const resizeReviewBody = () => {
    const textarea = document.querySelector('#jdgm-review-body-input');
    if (!textarea || !textarea.getClientRects().length) return;
    if (!window.matchMedia('(max-width:749px)').matches) {
      textarea.style.removeProperty('height');
      return;
    }
    textarea.style.setProperty('height', 'auto', 'important');
    const style = getComputedStyle(textarea);
    const borders = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
    textarea.style.setProperty('height', `${textarea.scrollHeight + borders}px`, 'important');
  };

  const enhanceReviewForm = () => {
    const textarea = document.querySelector('#jdgm-review-body-input');
    if (!textarea || textarea.parentElement.querySelector('.anya-review-fields')) return;
    const fields = document.createElement('div');
    fields.className = 'anya-review-fields';
    fields.append(
      buildCheckboxGroup('anya-review-scents', form.scent, form.scents),
      buildSelect('anya-review-pack', form.pack, form.packs),
      buildSelect('anya-review-duration', form.duration, form.durations)
    );
    const error = document.createElement('p');
    error.className = 'anya-review-fields__error';
    error.setAttribute('role', 'alert');
    fields.append(error);
    textarea.parentElement.insertBefore(fields, textarea.parentElement.firstChild);
  };

  const prepareReviewDetails = (event) => {
    const button = event.target.closest('button');
    const textarea = document.querySelector('#jdgm-review-body-input');
    const fields = textarea?.parentElement.querySelector('.anya-review-fields');
    if (!button || !textarea || !fields) return;
    const navigation = button.closest('[class*="navigation"]');
    const navigationButtons = navigation ? [...navigation.querySelectorAll('button')] : [];
    if (!navigation || button !== navigationButtons.at(-1)) return;
    const selects = [...fields.querySelectorAll('select')];
    const scentGroup = fields.querySelector('#anya-review-scents');
    const checkedScents = [...scentGroup.querySelectorAll('input:checked')];
    const missingSelects = selects.filter((select) => !select.value);
    if (!checkedScents.length || missingSelects.length) {
      event.preventDefault();
      event.stopImmediatePropagation();
      scentGroup.toggleAttribute('aria-invalid', !checkedScents.length);
      missingSelects.forEach((select) => select.setAttribute('aria-invalid', 'true'));
      fields.querySelector('.anya-review-fields__error').textContent = form.required;
      (!checkedScents.length ? scentGroup.querySelector('input') : missingSelects[0]).focus();
      return;
    }
    fields.querySelector('.anya-review-fields__error').textContent = '';
    const marker = '\n\n— ANYA —\n';
    const markerIndex = textarea.value.lastIndexOf(marker);
    const body = (markerIndex >= 0 ? textarea.value.slice(0, markerIndex) : textarea.value).trimEnd();
    const scentDetail = `${scentGroup.parentElement.dataset.anyaReviewDetail} : ${checkedScents.map((input) => input.value).join(', ')}`;
    const details = [scentDetail, ...selects.map((select) => `${select.dataset.anyaReviewDetail} : ${select.value}`)].join('\n');
    textarea.value = `${body}${marker}${details}`;
    textarea.dispatchEvent(new Event('input', { bubbles: true }));
    textarea.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const buildMediaCarousel = () => {
    const carousel = document.querySelector('[data-anya-review-media]');
    const track = carousel?.querySelector('[data-review-media-track]');
    if (!carousel || !track) return;
    const sources = [...document.querySelectorAll('#judgeme_product_reviews .jm-media-grid__image')];
    const getMediaUrl = (image) => (image.currentSrc || image.getAttribute('src') || '').split('?')[0];
    const unique = sources.filter((image, index, images) => {
      const key = getMediaUrl(image);
      return key && images.findIndex((candidate) => getMediaUrl(candidate) === key) === index;
    });
    if (!unique.length) return;
    const signature = unique.map(getMediaUrl).join('|');
    if (track.dataset.signature === signature) return;
    track.dataset.signature = signature;
    track.replaceChildren();
    unique.forEach((source, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'anya-review-media__item';
      button.setAttribute('aria-label', `${media.image_alt} ${index + 1}`);
      const image = document.createElement('img');
      image.src = `${getMediaUrl(source)}?quality=85&width=700`;
      image.alt = `${media.image_alt} ${index + 1}`;
      image.loading = 'lazy';
      button.append(image);
      button.addEventListener('click', () => source.closest('[role="button"]')?.click());
      track.append(button);
    });
    carousel.hidden = false;
    if (carousel.dataset.bound !== 'true') {
      carousel.dataset.bound = 'true';
      const scroll = (direction) => track.scrollBy({ left: direction * Math.max(track.clientWidth * 0.75, 220), behavior: 'smooth' });
      carousel.querySelector('[data-review-media-prev]').addEventListener('click', () => scroll(-1));
      carousel.querySelector('[data-review-media-next]').addEventListener('click', () => scroll(1));
    }
  };

  const localize = () => {
    const controls = isArabic ? {
      'Play review video': 'شغّل فيديو التقييم',
      'Go to previous page': 'الصفحة السابقة',
      'Go to next page': 'الصفحة التالية',
      'Pagination Navigation': 'التنقل بين صفحات التقييمات',
      'Loading thumbnail': 'كتحمّل الصورة',
      'Scroll thumbnails left': 'الصور السابقة',
      'Scroll thumbnails right': 'الصور التالية',
      'View review image': 'شوف صورة التقييم'
    } : {
      'Play review video': 'Lire la vidéo de cet avis',
      'Go to previous page': 'Page précédente',
      'Go to next page': 'Page suivante',
      'Pagination Navigation': 'Navigation entre les pages d’avis',
      'Loading thumbnail': 'Chargement de la miniature',
      'Scroll thumbnails left': 'Miniatures précédentes',
      'Scroll thumbnails right': 'Miniatures suivantes',
      'View review image': 'Voir la photo de l’avis'
    };
    document.querySelectorAll('.jdgm-widget [aria-label]').forEach(element => {
      const value = element.getAttribute('aria-label');
      const match = value.match(/^(\d+(?:\.\d+)?) out of 5 stars$/i);
      const page = value.match(/^Go to page (\d+)$/i);
      const item = value.match(/^Go to item (\d+)$/i);
      const thumbnails = value.match(/^Thumbnails for (\d+) items$/i);
      const translated = controls[value]
        || (item ? (isArabic ? `الصورة ${item[1]}` : `Photo ${item[1]}`) : null)
        || (thumbnails ? (isArabic ? `${thumbnails[1]} صور ديال التقييمات` : `${thumbnails[1]} photos d’avis`) : null)
        || (page ? (isArabic ? `الصفحة ${page[1]}` : `Page ${page[1]}`) : (match ? (isArabic ? stars.replace('{rating}', match[1]) : `${match[1]} sur 5 étoiles`) : value));
      if (value !== translated) element.setAttribute('aria-label',translated);
    });
    if (isArabic) {
      document.querySelectorAll(scope).forEach((root) => {
        [root, ...root.querySelectorAll('*')].forEach((element) => {
          for (const attribute of ['aria-label', 'title', 'placeholder']) {
            const value = element.getAttribute(attribute);
            if (value && translate(value) !== value) element.setAttribute(attribute, translate(value));
          }
          if (element.closest(excluded)) return;
          element.childNodes.forEach((node) => {
            if (node.nodeType !== Node.TEXT_NODE) return;
            const translated = translate(node.nodeValue);
            if (translated !== node.nodeValue) node.nodeValue = translated;
          });
        });
      });
      const starGroups = [...document.querySelectorAll('.jdgm-write-review-modal__stars')];
      starGroups.forEach((group) => group.classList.remove('anya-jdgm-stars-localized'));
      const visibleStarGroup = starGroups.find((group) => group.getClientRects().length > 0 && getComputedStyle(group).visibility !== 'hidden');
      visibleStarGroup?.classList.add('anya-jdgm-stars-localized');
    }
    formatReviewDates();
    enhanceReviewForm();
    resizeReviewBody();
    buildMediaCarousel();
  };

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      localize();
    });
  };

  document.addEventListener('click', prepareReviewDetails, true);
  document.addEventListener('input', (event) => {
    if (event.target.id === 'jdgm-review-body-input') resizeReviewBody();
  });
  document.addEventListener('focusin', (event) => {
    if (event.target.id === 'jdgm-review-body-input') resizeReviewBody();
  });
  window.addEventListener('resize', resizeReviewBody);
  window.addEventListener('resize', fitReviewViewport);
  window.visualViewport?.addEventListener('resize', fitReviewViewport);
  window.visualViewport?.addEventListener('scroll', fitReviewViewport);
  fitReviewViewport();
  new MutationObserver((records) => {
    if (records.some(({ target, addedNodes }) => {
      const element = target.nodeType === Node.ELEMENT_NODE ? target : target.parentElement;
      return element?.closest(scope) || [...addedNodes].some((node) => node.nodeType === Node.ELEMENT_NODE && (node.matches(scope) || node.querySelector(scope)));
    })) schedule();
  }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'title'] });
  localize();
})();
